import { render, staticRenderFns } from "./SearchOwner.vue?vue&type=template&id=a44542b6&scoped=true"
import script from "./SearchOwner.vue?vue&type=script&lang=js"
export * from "./SearchOwner.vue?vue&type=script&lang=js"
import style0 from "./SearchOwner.vue?vue&type=style&index=0&id=a44542b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44542b6",
  null
  
)

export default component.exports